import { ActivatedRoute, Router } from '@angular/router';
import { HotelPreview } from './../../../modules/results/results.container';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MouseEvent } from '@agm/core';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-map-canvas',
  templateUrl: 'map.component.html',
  styleUrls: ['map.component.css']
})
export class MapComponent implements OnInit {
  // google maps zoom level
  zoom = 8;
  @Input() markers: IMarker[];
  @Input() mapCenter;
  @Input() hotels;
  @Input() hasInfoWindow;
  @Input() zoomInfo;
  @Input() selectedHotel;
  @Input() openHotelPopup;
  @Input() iLat;
  @Input() iLon;

  @ViewChild('infoWindow') infoWindow;

  requestForSearch = {
    checkInDate: '',
    checkOutDate: '',
    requestId: null,
    or: true,
    adults: null,
    children: null,
  };

  // initial center position for the map
  lat;
  lng;
  windowOpen = false;
  // selectedHotel: HotelPreview;
  infoWindowOpened = null;
  openedId = -1;
  icon = {
    url: '../../../../../assets/img/marker.png',
    scaledSize: {
      width: 40,
      height: 40
    }
  };
  iconOffer = {
    url: '../../../../../assets/img/check.png',
    scaledSize: {
      width: 40,
      height: 40
    }
  };

  constructor(private router: Router, private route: ActivatedRoute, private angulartics2: Angulartics2) { }

  ngOnInit() {
    for (let l = 0; l < this.markers.length; l++) {
      for (let i = l + 1; i < this.markers.length; i++) {
        if (this.markers[l].label === this.markers[i].label) {
          if (this.markers[l].type !== 'Offer') {
            const index = this.markers.indexOf(this.markers[l], 0);
            if (index > -1) {
              this.markers.splice(index, 1);
            }
          } else {
            const index = this.markers.indexOf(this.markers[i], 0);
            if (index > -1) {
              this.markers.splice(index, 1);
            }
          }
        }
      }
    }
    this.iLat = '35.0564782';
    this.iLon = '24.2646407';
    this.lat = this.mapCenter.latitude;
    this.lng = this.mapCenter.longitude;
    // console.log(this.mapCenter);
    // console.log(this.selectedHotel);
    if (this.selectedHotel == null) {
      this.selectedHotel = this.hotels[0];
    }

    if (!this.zoomInfo) {
      this.zoomInfo = this.zoom;
    }
    this.route.queryParams.subscribe(params => {
      this.requestForSearch.checkInDate = params.checkInDate;
      this.requestForSearch.checkOutDate = params.checkOutDate;
      this.requestForSearch.adults = params.adults;
      this.requestForSearch.children = params.children;
      this.requestForSearch.requestId = params.requestId;
    });
  }

  getStars = (stars) => Array(stars).fill(1);

  getHotelPrice(id) {
    const h = this.hotels.find(hotel => hotel.id === id);
    if (h.minPrice !== null) { return h.minPrice.toString() + '€'; } else { return null; }
  }

  clickedMarker(infoWindow, index: number) {
    this.angulartics2.eventTrack.next({ action: 'ClickedPropertyOnMap' });
    /*this.selectedHotel = this.hotels.find(hotel => hotel.id === this.markers[index].label );
    console.log(this.infoWindowOpened);
    if (this.infoWindowOpened !== null) {
      console.log('------');
      this.infoWindowOpened.close();
    }
    this.infoWindowOpened = infoWindow;
    if (this.infoWindowOpened ===  infoWindow) { return; }
    console.log(this.infoWindowOpened);

    // this.infoWindowOpened.close();*/
    this.selectedHotel = this.hotels.find(hotel => hotel.id === this.markers[index].label);
    this.openedId = index;
    if (this.infoWindowOpened) {
      this.infoWindowOpened.close();
    }
    this.infoWindowOpened = infoWindow;
  }

  clickedHotel(hotel) {
    this.selectedHotel = hotel;
    // console.log(this.selectedHotel);
    // if (this.infoWindowOpened ===  this.infoWindow) { return; }
    // if (this.infoWindowOpened !== null) { this.infoWindowOpened.close(); }
    // console.log(this.infoWindow);
    // this.infoWindowOpened = this.infoWindow;
    // this.windowOpen = true;
  }

  mapClicked($event: MouseEvent) {
    /*this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });*/
  }

  isWindowOpen() {
    return this.windowOpen;
  }

  markerDragEnd(m: IMarker, $event: MouseEvent) { }

  isOpen(id) {
    return id === this.openedId;
  }

}

// just an interface for type safety.
export interface IMarker {
  lat: number;
  lng: number;
  label?: number;
  draggable: boolean;
  type?: String;
}
